import { createContext } from 'react'

export interface WhatsAppContextProps {
  whatsAppUrl?: string
  whatsAppWebUrl?: string
  customMessage?: string
  customMessageSlug?: string
}

export const WhatsAppContext = createContext<WhatsAppContextProps>({})
